<template>
  <v-stepper-content :step="step.index">
    <v-row
      justify="space-around"
      :class="{'mb-2': !fullWidth}"
    >
      <v-col
        :lg="lg"
        :xl="xl"
      >
        <v-card :elevation="fullWidth ? 0 : undefined">
          <v-card-title>
            <slot name="title" />
          </v-card-title>
          <v-card-subtitle>
            <slot name="subtitle" />
          </v-card-subtitle>
          <v-card-text>
            <mfa-step-error-display :errors="step.errors" />
            <slot />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-stepper-content>
</template>
<script>
import MfaStepErrorDisplay from './MfaStepErrorDisplay.vue'

export default {
  name: 'MfaStep',
  components: {
    MfaStepErrorDisplay
  },
  props: {
    step: { type: Object, required: true },
    fullWidth: { type: Boolean, default: false }
  },
  computed: {
    lg() {
      return this.fullWidth ? 12 : 6
    },
    xl() {
      return this.fullWidth ? 12 : 4
    }
  }
}
</script>
